module.exports = __webpack_public_path__ + "static/img/award4.a69165d.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/index/award4.png
// module id = BA97
// module chunks = 7